const COUNTRY_CODE_TO_PHONE_CODE = {
  BD: "880",
  BE: "32",
  BF: "226",
  BG: "359",
  BA: "387",
  BB: "+1-246",
  WF: "681",
  BL: "590",
  BM: "+1-441",
  BN: "673",
  BO: "591",
  BH: "973",
  BI: "257",
  BJ: "229",
  BT: "975",
  JM: "+1-876",
  BV: "",
  BW: "267",
  WS: "685",
  BQ: "599",
  BR: "55",
  BS: "+1-242",
  JE: "+44-1534",
  BY: "375",
  BZ: "501",
  RU: "7",
  RW: "250",
  RS: "381",
  TL: "670",
  RE: "262",
  TM: "993",
  TJ: "992",
  RO: "40",
  TK: "690",
  GW: "245",
  GU: "+1-671",
  GT: "502",
  GS: "",
  GR: "30",
  GQ: "240",
  GP: "590",
  JP: "81",
  GY: "592",
  GG: "+44-1481",
  GF: "594",
  GE: "995",
  GD: "+1-473",
  GB: "44",
  GA: "241",
  SV: "503",
  GN: "224",
  GM: "220",
  GL: "299",
  GI: "350",
  GH: "233",
  OM: "968",
  TN: "216",
  JO: "962",
  HR: "385",
  HT: "509",
  HU: "36",
  HK: "852",
  HN: "504",
  HM: " ",
  VE: "58",
  PR: "+1-787 and 1-939",
  PS: "970",
  PW: "680",
  PT: "351",
  SJ: "47",
  PY: "595",
  IQ: "964",
  PA: "507",
  PF: "689",
  PG: "675",
  PE: "51",
  PK: "92",
  PH: "63",
  PN: "870",
  PL: "48",
  PM: "508",
  ZM: "260",
  EH: "212",
  EE: "372",
  EG: "20",
  ZA: "27",
  EC: "593",
  IT: "39",
  VN: "84",
  SB: "677",
  ET: "251",
  SO: "252",
  ZW: "263",
  SA: "966",
  ES: "34",
  ER: "291",
  ME: "382",
  MD: "373",
  MG: "261",
  MF: "590",
  MA: "212",
  MC: "377",
  UZ: "998",
  MM: "95",
  ML: "223",
  MO: "853",
  MN: "976",
  MH: "692",
  MK: "389",
  MU: "230",
  MT: "356",
  MW: "265",
  MV: "960",
  MQ: "596",
  MP: "+1-670",
  MS: "+1-664",
  MR: "222",
  IM: "+44-1624",
  UG: "256",
  TZ: "255",
  MY: "60",
  MX: "52",
  IL: "972",
  FR: "33",
  IO: "246",
  SH: "290",
  FI: "358",
  FJ: "679",
  FK: "500",
  FM: "691",
  FO: "298",
  NI: "505",
  NL: "31",
  NO: "47",
  NA: "264",
  VU: "678",
  NC: "687",
  NE: "227",
  NF: "672",
  NG: "234",
  NZ: "64",
  NP: "977",
  NR: "674",
  NU: "683",
  CK: "682",
  XK: "",
  CI: "225",
  CH: "41",
  CO: "57",
  CN: "86",
  CM: "237",
  CL: "56",
  CC: "61",
  CA: "1",
  CG: "242",
  CF: "236",
  CD: "243",
  CZ: "420",
  CY: "357",
  CX: "61",
  CR: "506",
  CW: "599",
  CV: "238",
  CU: "53",
  SZ: "268",
  SY: "963",
  SX: "599",
  KG: "996",
  KE: "254",
  SS: "211",
  SR: "597",
  KI: "686",
  KH: "855",
  KN: "+1-869",
  KM: "269",
  ST: "239",
  SK: "421",
  KR: "82",
  SI: "386",
  KP: "850",
  KW: "965",
  SN: "221",
  SM: "378",
  SL: "232",
  SC: "248",
  KZ: "7",
  KY: "+1-345",
  SG: "65",
  SE: "46",
  SD: "249",
  DO: "+1-809 and 1-829",
  DM: "+1-767",
  DJ: "253",
  DK: "45",
  VG: "+1-284",
  DE: "49",
  YE: "967",
  DZ: "213",
  US: "1",
  UY: "598",
  YT: "262",
  UM: "1",
  LB: "961",
  LC: "+1-758",
  LA: "856",
  TV: "688",
  TW: "886",
  TT: "+1-868",
  TR: "90",
  LK: "94",
  LI: "423",
  LV: "371",
  TO: "676",
  LT: "370",
  LU: "352",
  LR: "231",
  LS: "266",
  TH: "66",
  TF: "",
  TG: "228",
  TD: "235",
  TC: "+1-649",
  LY: "218",
  VA: "379",
  VC: "+1-784",
  AE: "971",
  AD: "376",
  AG: "+1-268",
  AF: "93",
  AI: "+1-264",
  VI: "+1-340",
  IS: "354",
  IR: "98",
  AM: "374",
  AL: "355",
  AO: "244",
  AQ: "",
  AS: "+1-684",
  AR: "54",
  AU: "61",
  AT: "43",
  AW: "297",
  IN: "91",
  AX: "+358-18",
  AZ: "994",
  IE: "353",
  ID: "62",
  UA: "380",
  QA: "974",
  MZ: "258",
};

//Validates a phone number starting from + and has 6 digits after that
function validatePhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return false;
  }

  if (phoneNumber.length < 10) {
    return false;
  }

  if (!phoneNumber.startsWith("+")) {
    return false;
  }

  if (phoneNumber.startsWith("+91") && phoneNumber.length != 13) {
    return false;
  }

  if (
    phoneNumber.startsWith("+91") &&
    !["6", "7", "8", "9"].includes(phoneNumber.charAt(3))
  ) {
    return false;
  }

  let phoneNumberRegex = /^\+([0-9]{6}[0-9]*)$/;

  if (phoneNumber.match(phoneNumberRegex)) {
    return true;
  } else {
    return false;
  }
}

//https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
const validateEmail = (email) => {
  const matches = String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  return Boolean(matches);
};

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const simplify_jQuery_3_6_0 = $.noConflict(true);

/************************************************* client.js *******************************************************/

(function ($) {
  console.log("SUCCESS", "jquery version is ", $.fn.jquery);
  let SERVER_DOMAIN = "loginviaotp.com";

  let SHOP = window.location.hostname;

  let SHOPIFY_THEME = "no-theme";
  if (Shopify) {
    SHOP = Shopify.shop;

    if (Shopify.theme && Shopify.theme.name) {
      SHOPIFY_THEME = Shopify.theme.name;
    }

    if (SHOP == "testsimplifyloginembed.myshopify.com") {
      SERVER_DOMAIN = "staging.loginviaotp.com";
    }
  }

  console.log("Shopify url is: ", SHOP);

  let is_disabled = false;
  let allowedLoginMethod = "ONLY_EMAIL_PASSWORD";
  let isPhoneCodeHardcoded = false;
  let PHONE_CODE = "+91";
  let STORE_LANG = "ENGLISH";
  let autoFillOTPEnabled = true;
  let LOGIN_EXP = "new";
  let fields_during_signup = "EMAIL_ONLY";
  let RESEND_OTP_TIMER_ENABLED = false;
  let fb_login_enabled = false;
  let google_login_enabled = false;
  let selected_country_code = "All";
  let relative_route = "";
  let showTermsAndConditions = false;
  let isBiometricLoginEnabled = false;
  let FIREBASE_LEVEL = "DISABLED"; // ALL_NUMBERS, ONLY_INTERNATIONAL_NUMBERS
  let FIREBASE_CONFIG;
  const CRED_KEY_STRING = "sml-cred";

  const initExtension = () => {
    let simplifyURLParams = new URLSearchParams(window.location.search);

    if (simplifyURLParams.has("simplify_is_disabled")) {
      is_disabled = simplifyURLParams.get("simplify_is_disabled") == "true";
    }

    if (simplifyURLParams.has("simplify_allowed_login_method")) {
      allowedLoginMethod = simplifyURLParams.get(
        "simplify_allowed_login_method"
      );
    }

    if (simplifyURLParams.has("simplify_login_exp")) {
      LOGIN_EXP = simplifyURLParams.get("simplify_login_exp");
    }

    if (is_disabled) {
      //make sign in form appear back

      let signInForm = document.getElementById("customer_login");

      if (!signInForm) {
        console.log(
          "Strange #customer_login not found, trying CustomerLoginForm"
        );
        signInForm = document.getElementById("CustomerLoginForm");
      }

      if (signInForm) {
        console.log("Showing signInForm");
        // signInForm.style.display = "block"
        signInForm.style.visibility = "visible";
      }

      throw new Error("Extension is disabled");
    }

    if (SHOP.indexOf("yashteststore") > -1) {
    }

    if (selected_country_code != "All") {
      isPhoneCodeHardcoded = true;
    }

    if (
      SHOP.indexOf("kamikamiburger") > -1 ||
      SHOP.indexOf("manas4hazard") > -1
    ) {
      RESEND_OTP_TIMER_ENABLED = true;
    }

    if (SHOP.indexOf("therouc") > -1) {
      showTermsAndConditions = true;
    }

    let isIpInfoRequestPending = true;
    if (!isPhoneCodeHardcoded) {
      $.get("https://ipinfo.io", function () {}, "jsonp").always(function (
        resp
      ) {
        console.log("ipinfo resp", resp);
        if (resp && resp.country) {
          const countryCode = resp.country.toUpperCase();
          if (COUNTRY_CODE_TO_PHONE_CODE[countryCode]) {
            PHONE_CODE = "+" + COUNTRY_CODE_TO_PHONE_CODE[countryCode];
          }
        }
        isIpInfoRequestPending = false;
      });
    } else {
      isIpInfoRequestPending = false;
    }

    let PHONE_NUMBER_TEXT = "Phone number";
    let EMAIL_PHONE_NUMBER_TEXT = "Email/Phone number";
    let OTP_TEXT = "OTP";
    let PASSWORD_OTP_TEXT = "Password/OTP";
    let GET_OTP_TEXT = "Get OTP";
    let EMAIL_TEXT = "Email";
    let SUBMIT_OTP_TEXT = "Submit OTP";
    let REGISTER_AND_LOGIN_TEXT = "Login";
    let EDIT_PHONE_TEXT = "Edit phone number";
    let RESEND_OTP_TEXT = "Resend OTP";
    let LOGIN_SIGN_UP_TEXT = "Login/Sign up";
    let CONTINUE_WITH_TEXT = "Or continue with";
    let LOGIN_REGISTER_WITH_PHONE_NUMBER = "Login/Register with Phone Number";
    let LOGIN_WITH_EMAIL_TEXT = "Login with Email";
    let FIRST_NAME_TEXT = "First Name";
    let LAST_NAME_TEXT = "Last Name";
    let OTP_SENT_SUCCESSFULLY_TEXT =
      "OTP sent successfully on phone, please enter it below";
    let OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT =
      "Not able to send otp. Please try again";
    let ENTER_VALID_NUMBER = "Please enter a valid number";
    let ENTER_VALID_OTP = "Please enter a valid 4 digit OTP";
    let ENTER_VALID_SIX_DIGIT_OTP = "Please enter a valid 6 digit OTP";
    let ENTER_VALID_FIRST_NAME = "Please enter a valid first name";
    let ENTER_VALID_LAST_NAME = "Please enter a valid last name";
    let ENTER_VALID_EMAIL = "Please enter a valid email";
    let OTP_SUCCESSFULLY_VERIFIED = "Successfully verified otp, logging you in";
    let ENTER_EMAIL_REGISTER_LOGIN =
      "Please enter your email id to register and login";
    let OTP_VALIDATION_UNABLED = "Not able to validate otp.";
    let USER_REGISTRATION_UNABLED = "Not able to register user.";
    let EMAIL_TAKEN_WITHOUT_CLICK =
      "This email is already taken. Please provide different email";
    let EMAIL_TAKEN_WITH_CLICK =
      "This email is already taken. Please provide different email or use Email/Password to login by";
    let CLICKING_HERE = "clicking here.";
    let SUCCESSFULLY_REGISTERED_USER =
      "Successfully registered user, logging you in";
    let OTP_SEND_UNABLE = "Not able to send otp. Error:";
    let OTP_SENT_SUCCESSFULLY_TEXT_EMAIL =
      "Existing user found with given email, please enter OTP sent on email to verify email ownership";
    let OTP_SENT_SUCCESS_MESSAGE = "OTP sent successfully on phone and email";
    let ENTER_IT_BELOW_TEXT = "please enter it below";
    let SIGN_IN_WITH_GOOGLE = "Sign in with Google";
    let SIGN_IN_WITH_FACEBOOK = "Sign in with Facebook";
    let LOGIN_WITH_BIOMETRIC_TEXT = "Login with device";

    if (STORE_LANG == "ARABIC") {
      PHONE_NUMBER_TEXT = "رقم الهاتف";
      EMAIL_PHONE_NUMBER_TEXT = "البريد الإلكتروني / رقم الهاتف";
      OTP_TEXT = "رمز التحقق";
      PASSWORD_OTP_TEXT = "كلمة المرور / رمز التحقق";
      GET_OTP_TEXT = "احصل على رمز التحقق";
      EMAIL_TEXT = "البريد الإلكتروني";
      SUBMIT_OTP_TEXT = "إرسال رمز التحقق";
      REGISTER_AND_LOGIN_TEXT = "تسجيل الدخول";
      EDIT_PHONE_TEXT = "تحرير رقم الهاتف";
      RESEND_OTP_TEXT = "إعادة إرسال رمز التحقق";
      LOGIN_SIGN_UP_TEXT = "الدخول / التسجيل";
      CONTINUE_WITH_TEXT = "أو تواصل مع";
      LOGIN_REGISTER_WITH_PHONE_NUMBER =
        "تسجيل الدخول / التسجيل باستخدام رقم الهاتف";
      LOGIN_WITH_EMAIL_TEXT = "تسجيل الدخول بالبريد الإلكتروني";
      OTP_SENT_SUCCESSFULLY_TEXT =
        "تم إرسال رمز التحقق بنجاح على الهاتف ، يرجى إدخاله أدناه";
      OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT =
        "غير قادر على إرسال رمز التحقق. حاول مرة اخرى";
      ENTER_VALID_NUMBER = "يرجى إدخال رقم هاتف صحيح";
      ENTER_VALID_OTP = "الرجاء إدخال رمز تحقق صالح مكون من 4 أرقام";
      ENTER_VALID_FIRST_NAME = "الرجاء إدخال الاسم الأول بشكل صحيح";
      ENTER_VALID_LAST_NAME = "يرجى إدخال الاسم الاخير بشكل صحيح";
      ENTER_VALID_EMAIL = "يرجى إدخال البريد الإلكتروني بشكل صحيح";
      OTP_SUCCESSFULLY_VERIFIED =
        "تم التحقق من الرمز بنجاح، لقد قمت بتسجيل الدخول";
      ENTER_EMAIL_REGISTER_LOGIN =
        "الرجاء إدخال بريدك الالكتروني لتسجيل الدخول";
      OTP_VALIDATION_UNABLED = "غير قادر على التحقق من صحة الرمز.";
      USER_REGISTRATION_UNABLED = "غير قادر على إنشاء حساب.";
      EMAIL_TAKEN_WITHOUT_CLICK =
        "البريد إلكتروني مستخدم في حساب اخر. يرجى إدخال بريد إلكتروني مختلف";
      EMAIL_TAKEN_WITH_CLICK =
        "الايميل أخذ مسبقا. يرجى تقديم بريد إلكتروني مختلف أو استخدام البريد الإلكتروني / كلمة المرور لتسجيل الدخول عن طريق";
      CLICKING_HERE = "النقر هنا";
      SUCCESSFULLY_REGISTERED_USER = "تم إنشاء حسابك بنجاح";
      OTP_SEND_UNABLE = "خطأ: غير قادر على إرسال رمز التحقق";
      OTP_SENT_SUCCESSFULLY_TEXT_EMAIL =
        "تم العثور على مستخدم موجود مع بريد إلكتروني معين ، يرجى إدخال رمز التحقق المرسل على البريد الإلكتروني للتحقق من ملكية البريد الإلكتروني";
      OTP_SENT_SUCCESS_MESSAGE =
        "تم إرسال رمز التحقق بنجاح عبر الهاتف والبريد الإلكتروني";
      ENTER_IT_BELOW_TEXT = "الرجاء إدخاله أدناه";
    }

    if (STORE_LANG == "ITALIAN") {
      PHONE_NUMBER_TEXT = "Numero di telefono";
      EMAIL_PHONE_NUMBER_TEXT = "E-mail/Numero di telefono";
      OTP_TEXT = "Codice di verifica";
      PASSWORD_OTP_TEXT = "Parola d'ordine/ Codice di verifica";
      GET_OTP_TEXT = "Ottieni il codice di verifica";
      EMAIL_TEXT = "E-mail";
      SUBMIT_OTP_TEXT = "Invia il codice di verifica";
      REGISTER_AND_LOGIN_TEXT = "Login";
      EDIT_PHONE_TEXT = "Modifica numero di telefono";
      RESEND_OTP_TEXT = "Invia nuovamente il codice di verifica";
      LOGIN_SIGN_UP_TEXT = "Accedi/Iscriviti";
      CONTINUE_WITH_TEXT = "Oppure continua con";
      LOGIN_REGISTER_WITH_PHONE_NUMBER =
        "Accedi/Registrati con il numero di telefono";
      LOGIN_WITH_EMAIL_TEXT = "Accedi con e-mail";
      FIRST_NAME_TEXT = "Nome di battesimo";
      LAST_NAME_TEXT = "Cognome";
      OTP_SENT_SUCCESSFULLY_TEXT =
        "Codice di verifica inviato con successo sul telefono, inseriscilo di seguito";
      OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT =
        "Impossibile inviare il codice di verifica. Per favore riprova";
      ENTER_VALID_NUMBER = "Per favore, inserire un numero valido";
      ENTER_VALID_OTP = "Inserisci un codice di verifica a 4 cifre valido";
      ENTER_VALID_FIRST_NAME =
        "Per favore inserire un nome di battesimo valido";
      ENTER_VALID_LAST_NAME = "Si prega di inserire un cognome valido";
      ENTER_VALID_EMAIL = "Inserisci una email valida";
      OTP_SUCCESSFULLY_VERIFIED =
        "Codice di verifica convalidato con successo, accedi";
      ENTER_EMAIL_REGISTER_LOGIN =
        "Inserisci la tua e-mail per registrarti ed effettuare il login";
      OTP_VALIDATION_UNABLED = "Impossibile convalidare il codice di verifica.";
      USER_REGISTRATION_UNABLED = "Impossibile registrare l'utente.";
      EMAIL_TAKEN_WITHOUT_CLICK =
        "Questo indirizzo e-mail è già in uso. Si prega di fornire un'e-mail diversa";
      EMAIL_TAKEN_WITH_CLICK =
        "Questo indirizzo e-mail è già in uso. Si prega di fornire un'e-mail diversa o utilizzare l'e-mail/password per accedere";
      CLICKING_HERE = "cliccando qui.";
      SUCCESSFULLY_REGISTERED_USER =
        "Utente registrato con successo, effettua il login";
      OTP_SEND_UNABLE = "Impossibile inviare il codice di verifica. Errore:";
      OTP_SENT_SUCCESSFULLY_TEXT_EMAIL =
        "Utente esistente trovato con l'e-mail fornita, inserisci il codice di verifica inviato nell'e-mail per verificare la proprietà dell'e-mail";
      OTP_SENT_SUCCESS_MESSAGE =
        "Codice di verifica inviato con successo su telefono ed e-mail";
      ENTER_IT_BELOW_TEXT = "si prega di inserirlo qui sotto";
    }

    if (STORE_LANG == "Chinese(Traditional)") {
      PHONE_NUMBER_TEXT = "手機號碼";
      EMAIL_PHONE_NUMBER_TEXT = "信箱/手機號碼";
      OTP_TEXT = "驗證碼";
      PASSWORD_OTP_TEXT = "密碼/驗證碼";
      GET_OTP_TEXT = "取得驗證碼";
      EMAIL_TEXT = "信箱";
      SUBMIT_OTP_TEXT = "提交驗證碼";
      REGISTER_AND_LOGIN_TEXT = "登入";
      EDIT_PHONE_TEXT = "編輯手機號碼";
      RESEND_OTP_TEXT = "重新發送驗證碼";
      LOGIN_SIGN_UP_TEXT = "登入/註冊";
      CONTINUE_WITH_TEXT = "或使用以下方式登入";
      LOGIN_REGISTER_WITH_PHONE_NUMBER = "使用手機號碼登入/註冊";
      LOGIN_WITH_EMAIL_TEXT = "使用信箱登入";
      FIRST_NAME_TEXT = "名字";
      LAST_NAME_TEXT = "姓氏";
      OTP_SENT_SUCCESSFULLY_TEXT = "驗證碼已成功發送，請在下方輸入";
      OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT = "驗證碼無效，請重新嘗試";
      ENTER_VALID_NUMBER = "請輸入正確數字";
      ENTER_VALID_OTP = "請輸入正確四位數驗證碼";
      ENTER_VALID_FIRST_NAME = "請輸入名字";
      ENTER_VALID_LAST_NAME = "請輸入姓氏";
      ENTER_VALID_EMAIL = "請輸入信箱";
      OTP_SUCCESSFULLY_VERIFIED = "驗證碼通過，已成功登入";
      ENTER_EMAIL_REGISTER_LOGIN = "請輸入您的信箱註冊或登入帳號";
      OTP_VALIDATION_UNABLED = "無法驗證此驗證碼";
      USER_REGISTRATION_UNABLED = "此帳號無法註冊";
      EMAIL_TAKEN_WITHOUT_CLICK = "請提供其他信箱";
      EMAIL_TAKEN_WITH_CLICK = "此信箱已被註冊，請使用其他信箱註冊、登入";
      CLICKING_HERE = "點擊此處";
      SUCCESSFULLY_REGISTERED_USER = "已成功註冊";
      OTP_SEND_UNABLE = "錯誤，無法成功發送驗證碼";
      OTP_SENT_SUCCESSFULLY_TEXT_EMAIL =
        "此信箱已被註冊，請輸入透過信箱發送的驗證碼驗證此帳戶";
      OTP_SENT_SUCCESS_MESSAGE = "手機和郵箱發送驗證碼成功";
      ENTER_IT_BELOW_TEXT = "請在下面輸入";
      SIGN_IN_WITH_GOOGLE = "使用 Google 帳號登入";
      SIGN_IN_WITH_FACEBOOK = "使用Facebook帳號登入";
    }

    if (SHOP.indexOf("iron-kettle-tea") > -1) {
      LOGIN_SIGN_UP_TEXT = "OTP LOGIN";
    }

    if (SHOP == "ohana-fine-flowers.myshopify.com") {
      LOGIN_SIGN_UP_TEXT = "LOGIN";
    }

    if (SHOP == "feelzerog.myshopify.com") {
      LOGIN_SIGN_UP_TEXT = "Log in to Shoely";
      LOGIN_REGISTER_WITH_PHONE_NUMBER = "Login with Phone Number";
    }

    if (SHOP == "opatra-5041.myshopify.com") {
      LOGIN_SIGN_UP_TEXT = `ברוכים הבאים!
              אם קיבלת את הקישור לכאן את כבר מיוחדת!
              התחברי בעזרת הטלפון הסלולרי שלך וקבלי את ההטבה שהיום קיבלת בסניף!
              זכרי זה תקף רק ל 24 שעות, היכנסי לגלות את העולם של אופטרה`;

      GET_OTP_TEXT = "התחברי עכשיו";

      PHONE_NUMBER_TEXT = "מספר טלפון";
    }

    let signInForm = $("#customer_login");

    if (signInForm.length == 0) {
      //https://niyatee.com/account/login
      console.log(
        "Strange #customer_login not found, trying CustomerLoginForm"
      );
      signInForm = $("#CustomerLoginForm");

      if (signInForm.length == 0) {
        throw new Error(
          "Sign in form not found, tried CustomerLoginForm and customer_login"
        );
      }
    }

    const createAccountLink = $('a[href="/account/register"]', signInForm);
    const forgotPasswordLink = $('a[href="#recover"]', signInForm);
    const emailInputBox = $("input[name=customer\\[email\\]]", signInForm);
    const passwordInputBox = $(
      "input[name=customer\\[password\\]]",
      signInForm
    );
    const emailInputBoxLabel = $(
      'label[for="' + emailInputBox.attr("id") + '"]',
      signInForm
    );
    const passwordInputBoxLabel = $(
      'label[for="' + passwordInputBox.attr("id") + '"]',
      signInForm
    );
    let signInButton = $("button[type!=button]", signInForm);

    if (signInButton.length == 0) {
      //needed for https://wooum.com/account/login
      signInButton = $("input[type=submit]", signInForm);
    }

    const createPhoneOptions = () => {
      let phoneOptions = "";
      if (selected_country_code != "All") {
        phoneOptions = `<option role='option' selected='selected' value='+${selected_country_code}'>+${selected_country_code}</option>`;
      } else {
        for (const countryCode in COUNTRY_CODE_TO_PHONE_CODE) {
          const phoneCode = COUNTRY_CODE_TO_PHONE_CODE[countryCode];
          phoneOptions += `<option role='option' selected='' value='+${phoneCode}'>+${phoneCode} ${countryCode}</option>`;
        }
      }
      return phoneOptions;
    };

    const phoneInputBoxHTML = `
  
              <style>
              #resendOTPButton {
                  ${showTermsAndConditions ? `--border-opacity: calc()` : ``};
              }
              #resendEmailOTPButton {
                  ${showTermsAndConditions ? `--border-opacity: calc()` : ``};
              }
              </style>
  
              <div id="mobileOTPLoginSection" >
                  <div id="simplify-login-sign-up-text" class="h1 h1-margin">${LOGIN_SIGN_UP_TEXT}</div>
                  <div id="loginError"></div>
                  <div id="loginSuccess"></div>
                  <div class="selectbox-wrapper">
                  <label for="mobileCountryCodeDropdown" style="display:none">Country code</label>
                  <select id="mobileCountryCodeDropdown">
                  ${createPhoneOptions()}
                  </select>
                  <label for="phoneNumberInput" style="display:none">Phone Number</label>
                  <input type="tel" id="phoneNumberInput" autofocus value="" placeholder="${PHONE_NUMBER_TEXT}">
                  </div>
                  <button type='button' id='getOTPButton'>${GET_OTP_TEXT}</button>
  
                  <div id="phoneNumberAndEditDiv">
                      <div id="phoneNumberDiv"></div>
                      <button type='button' id='backToLoginButton'>
                          <svg class="edit-phone bi bi-pencil-fill" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"></path>
                          </svg>
                      </button>
                  </div>
  
                  <div id="emailAndEditDiv">
                      <div id="emailDiv"></div>
                      <button type='button' id='backToLoginButtonEmailOtp'>
                          <svg class="edit-phone bi bi-pencil-fill" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"></path>
                          </svg>
                      </button>
                  </div>
                  <input type="tel" id="otpInput" placeholder="" maxlength="4" autocomplete="off"/>
                  <input type="tel" id="otpInputSixDigit" placeholder="" maxlength="6" autocomplete="off"/>
                  <div id="termsAndConditionsDiv">
                      <input type="checkbox" id="termsAndConditionsCheckbox" />
                      <label for="termsAndConditionsCheckbox" id="termsAndConditionsText">
                          I agree to the <a href="https://therouc.com/pages/privacy-policy" target="_blank" style="display: inline;">Terms and Conditions</a>
                      </label>
                  </div>
                  <button type='button' id='submitOTPButton'>${SUBMIT_OTP_TEXT}</button>
                  <input type="tel" id="emailOtpInput" placeholder="" maxlength="4" autocomplete="off"/>
                  <button type='button' id='submitEmailOTPButton'>${SUBMIT_OTP_TEXT}</button>
                  <p id='countdown'></p>
                  <button type='button' id='resendOTPButton'>${RESEND_OTP_TEXT}</button>
                  <button type='button' id='resendEmailOTPButton'>${RESEND_OTP_TEXT}</button>
                  <input type="text" id="userFirstNameInput" placeholder="${FIRST_NAME_TEXT}" />
                  <input type="text" id="userLastNameInput" placeholder="${LAST_NAME_TEXT}" />
                  <input type="text" id="userEmailInput" placeholder="${EMAIL_TEXT}" />
                  <div id="userBirthdayInputDiv">
                      <label id="userBirthdayInputLabel" for="userBirthdayInput">Birthday</label>
                      <input type="date" id="userBirthdayInput" />
                  </div>
                  <div id="userGenderInputDiv">
                      <label id="userGenderInputLabel" for="userGenderInput">Gender</label>
                      <div id="userGenderRadioButtonsInputDiv">
                          <input type="radio" name="userGenderInput" value="male" placeholder="Male" /> Male
                          <input type="radio" name="userGenderInput" value="female" placeholder="Female" /> Female
                      </div>
                  </div>
                  <button type='button' id='registerUserButton'>${REGISTER_AND_LOGIN_TEXT}</button>
              </div>
              `;

    const spinnerHTML = `
          <div id="spinner" style="display:none">
              <img src="https://${SERVER_DOMAIN}/static/img/loading.gif" alt="Loading" id='sml-spinner-img'/>
          </div>`;
    signInForm.after(spinnerHTML);
    signInForm.prepend(phoneInputBoxHTML);

    const otherLoginMethodsHTML = `
              <div id="otherLoginMethodsDiv">
                  <button type="button" id="loginWithPhoneNumberButton">${LOGIN_REGISTER_WITH_PHONE_NUMBER}</button>
                  <button type="button" id="loginWithEmailButton">${LOGIN_WITH_EMAIL_TEXT}</button>
                  <button type="button" id="loginWithBiometricButton">${LOGIN_WITH_BIOMETRIC_TEXT}</button>
              </div>`;

    const googleLoginDiv = `
          <div class="socialLogin_buttons" >
              <a href="#" class="google_button" id="googleLogin" role="button" tabindex="0" aria-label="${SIGN_IN_WITH_GOOGLE}">

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M21.8055 10.0415H21V10H12V14H17.6515C16.827 16.3285 14.6115 18 12 18C8.6865 18 6 15.3135 6 12C6 8.6865 8.6865 6 12 6C13.5295 6 14.921 6.577 15.9805 7.5195L18.809 4.691C17.023 3.0265 14.634 2 12 2C6.4775 2 2 6.4775 2 12C2 17.5225 6.4775 22 12 22C17.5225 22 22 17.5225 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#FFC107"/>
<path d="M3.15283 7.3455L6.43833 9.755C7.32733 7.554 9.48033 6 11.9998 6C13.5293 6 14.9208 6.577 15.9803 7.5195L18.8088 4.691C17.0228 3.0265 14.6338 2 11.9998 2C8.15883 2 4.82783 4.1685 3.15283 7.3455Z" fill="#FF3D00"/>
<path d="M12.0002 21.9999C14.5832 21.9999 16.9302 21.0114 18.7047 19.4039L15.6097 16.7849C14.5719 17.5741 13.3039 18.0009 12.0002 17.9999C9.39916 17.9999 7.19066 16.3414 6.35866 14.0269L3.09766 16.5394C4.75266 19.7779 8.11366 21.9999 12.0002 21.9999Z" fill="#4CAF50"/>
<path d="M21.8055 10.0415H21V10H12V14H17.6515C17.2571 15.1082 16.5467 16.0766 15.608 16.7855L15.6095 16.7845L18.7045 19.4035C18.4855 19.6025 22 17 22 12C22 11.3295 21.931 10.675 21.8055 10.0415Z" fill="#1976D2"/>
</svg>
                  <span class="h_google_text">
                      ${SIGN_IN_WITH_GOOGLE}
                  </span>
              </a>
          </div>
              `;
    const fbLoginDiv = `
          <div class="socialLogin_buttons" >
              <a href="#" class="facebook_button" id="fbLogin" role="button" tabindex="0" aria-label="${SIGN_IN_WITH_FACEBOOK}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="&#10;">
<path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z" fill="white"/>
</svg>
                  <span class="h_facebook_text">
                      ${SIGN_IN_WITH_FACEBOOK}
                  </span>
              </a>
          </div>
          `;

    const orContinueWith = `
          <p class="continue_text">${CONTINUE_WITH_TEXT}</p>
          `;
    const mobileOTPLoginSection = $("#mobileOTPLoginSection", signInForm);
    const getOTPButton = $("#getOTPButton", signInForm);
    const mobileCountryCodeDropdown = $(
      "#mobileCountryCodeDropdown",
      signInForm
    );
    const phoneNumberInput = $("#phoneNumberInput", signInForm);
    const phoneNumberDiv = $("#phoneNumberDiv", signInForm);
    const emailDiv = $("#emailDiv", signInForm);
    const errorBox = $("#loginError", signInForm);
    const successBox = $("#loginSuccess", signInForm);
    const submitOTPButton = $("#submitOTPButton", signInForm);
    const otpInput = $("#otpInput", signInForm);
    const otpInputSixDigit = $("#otpInputSixDigit", signInForm);
    const submitEmailOTPButton = $("#submitEmailOTPButton", signInForm);
    const emailOtpInput = $("#emailOtpInput", signInForm);
    const userEmailInput = $("#userEmailInput", signInForm);
    const registerUserButton = $("#registerUserButton", signInForm);
    const backToLoginButton = $("#backToLoginButton", signInForm);
    const backToLoginButtonEmailOtp = $(
      "#backToLoginButtonEmailOtp",
      signInForm
    );
    const resendOTPButton = $("#resendOTPButton");
    const resendEmailOTPButton = $("#resendEmailOTPButton", signInForm);
    const userFirstNameInput = $("#userFirstNameInput", signInForm);
    const userLastNameInput = $("#userLastNameInput", signInForm);
    const resendCountdownTimer = $("#countdown", signInForm);
    const termsAndConditionsDiv = $("#termsAndConditionsDiv", signInForm);
    const termsAndConditionsCheckbox = $(
      "#termsAndConditionsCheckbox",
      signInForm
    );
    const termsAndConditionsText = $("#termsAndConditionsText", signInForm);

    signInForm.append(orContinueWith);

    if (google_login_enabled) {
      signInForm.append(googleLoginDiv);
      const redirectToGoogle = $("#googleLogin", signInForm);
      redirectToGoogle.click(() => {
        SHOP = encodeURIComponent(SHOP);
        redirect_to =
          "https://" + SERVER_DOMAIN + "/account/google?shop=" + SHOP;
        window.location.assign(redirect_to);
      });
    }

    if (fb_login_enabled) {
      signInForm.append(fbLoginDiv);
      const redirectToFB = $("#fbLogin", signInForm);
      redirectToFB.click(() => {
        SHOP = encodeURIComponent(SHOP);
        redirect_to = "https://" + SERVER_DOMAIN + "/account/fb?shop=" + SHOP;
        window.location.assign(redirect_to);
      });
    }

    signInForm.append(otherLoginMethodsHTML);

    const loginWithEmailButton = $("#loginWithEmailButton", signInForm);
    const loginWithBiometricButton = $("#loginWithBiometricButton", signInForm);
    const loginWithPhoneNumberButton = $(
      "#loginWithPhoneNumberButton",
      signInForm
    );
    const otherLoginMethodsDiv = $("#otherLoginMethodsDiv", signInForm);
    const continue_text = $(".continue_text", signInForm);

    loginWithEmailButton.click(() => {
      selectLoginMethodScreen("EMAIL_PASSWORD");
    });

    loginWithPhoneNumberButton.click(() => {
      selectLoginMethodScreen("PHONE_OTP");
    });

    const displaySpinner = (shouldDisplay) => {
      if (shouldDisplay) {
        signInForm.hide();
        $("#spinner").show();
      } else {
        signInForm.show();
        $("#spinner").hide();
        console.log("hide");
      }
    };

    loginWithBiometricButton.click(async () => {
      let webauthnCred = localStorage.getItem(CRED_KEY_STRING);
      console.log("Found cred id in local: ", webauthnCred);

      if (!webauthnCred) {
        console.error("No cred id found, this should never happen");
        return;
      }

      webauthnCred = JSON.parse(webauthnCred)[0];

      const opts = await $.ajax({
        type: "POST",
        url: "/apps/sml/wan/init-auth",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          actual_shop_url: window.location.hostname,
          cred_id: webauthnCred.credId,
          reqtimestamp: Date.now(),
        }),
      });
      console.log("init auth resp", opts);

      if (opts.allowCredentials.length === 0) {
        console.error(
          "No registered credentials found., this should never happen"
        );
        return;
      }

      const { startAuthentication } = SimpleWebAuthnBrowser;

      let authInitResp;
      try {
        authInitResp = await startAuthentication(opts);
      } catch (err) {
        console.error("Error in starting webauthn", err);
        return;
      }

      console.log("authInitResp is: ", authInitResp);
      displaySpinner(true);

      let verificationResp;
      try {
        verificationResp = await $.ajax({
          type: "POST",
          url: "/apps/sml/wan/complete-auth",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            auth_credential: authInitResp,
            actual_shop_url: window.location.hostname,
            cred_id: webauthnCred.credId,
            first_name: webauthnCred.firstName,
            last_name: webauthnCred.last_name,
            reqtimestamp: Date.now(),
          }),
        });
      } catch (ex) {
        displaySpinner(false);
        console.error("Error in getting verificationResp", ex);
        errorBox.html("Error in logging in with device");
        return;
      }

      console.log("verificationResp", verificationResp);

      emailInputBox.val(verificationResp.email);
      passwordInputBox.val(verificationResp.xattr);
      signInButton.click();

      setTimeout(() => {
        displaySpinner(false);
      }, 3000);
    });

    const selectLoginMethodScreen = (screenType) => {
      if (screenType == "PHONE_OTP") {
        mobileOTPLoginSection.show();

        loginWithPhoneNumberButton.hide();

        if (allowedLoginMethod == "EMAIL_AND_PHONE") {
          loginWithEmailButton.show();
        }

        emailInputBox.hide();
        passwordInputBox.hide();
        emailInputBoxLabel.hide();
        passwordInputBoxLabel.hide();
        signInButton.hide();
        forgotPasswordLink.hide();

        if (emailInputBox.parent().attr("id") != signInForm.attr("id")) {
          emailInputBox.parent().hide();
        }

        if (passwordInputBox.parent().attr("id") != signInForm.attr("id")) {
          passwordInputBox.parent().hide();
        }

        //https://mauli-india.myshopify.com/account/login
        $('h1.h3.mb-3:contains("Login")').hide();

        //https://tikitoro.com/account/login
        $("#RecoverPasswordForm").hide();
        $("div.title_block").hide();
        $("div.bank_register").hide();

        // https://floryo.com/
        $('a[href$="#recover"]').attr("style", "display:none !important");

        //dont' do this for https://dev-shantibanaras.myshopify.com/password as asked by them over email
        if (
          SHOP.indexOf("shantibanaras") == -1 &&
          SHOP != "doro-fashions.myshopify.com"
        ) {
          $('a[href$="/account/register"]').attr(
            "style",
            "display:none !important"
          );
          createAccountLink.hide();
        }

        //https://leccygenesis.com/account/login
        if (SHOP.indexOf("leccygenesis") > -1) {
          $(".login-form-container").hide();
        }

        $(':contains("Forgot your password?"):last').hide();

        // hide forgot your password link on https://www.casivly.com/account/login
        $(".additional-links").hide();
        $(".tt-required").hide();

        //https://flourish.shop/account/login?return_url=%2Faccount
        $("header.section-header").hide();

        $('label[for="CustomerPassword"]').hide();
        $('label[for="CustomerEmail"]').hide();
        $('a[href="#recover-form"]').hide();

        //https://www.fionadiamonds.com/account/login
        $('h2.main-heading:contains("Customer Login")').hide();

        // https://darbeauty.com/account/login
        $('h2:contains("تسجيل الدخول")').hide();

        //https://houseofzelena.com/
        $('button:contains("Forgot your password?")').hide();
        $('h1.login__heading:contains("Login")').hide();

        //remove original login text
        if (
          $("#login").length == 1 &&
          $("#login").text() == "\n    Login\n  "
        ) {
          $("#login").hide();
        }

        if (
          $("#CustomerLoginForm").length == 1 &&
          $("h2", "#CustomerLoginForm").text() == "Login"
        ) {
          $("h2", "#CustomerLoginForm").hide();
        }

        if (SHOP.indexOf("suta") > -1) {
          $("header.Form__Header").hide();
          $("div.Form__Hint").hide();
          $("button.Form__ItemHelp").hide();
        }

        if (SHOPIFY_THEME.indexOf("Riode") > -1) {
          $("ul.nav.nav-tabs.align-items-center").hide();
        }

        if (SHOP == "thesovereignsectprebook.myshopify.com") {
          $("#simplify-login-sign-up-text").insertBefore(
            "#mobileOTPLoginSection"
          );
          otherLoginMethodsDiv.insertBefore("#mobileOTPLoginSection");
          $("#troubleLoggingInDiv").show();
          continue_text.hide();
        }

        if (SHOP == "app99.myshopify.com") {
          $("header.form__header", signInForm).hide();
          $("div.form__secondary-action", signInForm).hide();
        }

        if (SHOP == "doro-fashions.myshopify.com") {
          $("#otherLoginMethodsDiv").insertAfter("#mobileOTPLoginSection");
        }
      }

      if (screenType == "EMAIL_PASSWORD") {
        mobileOTPLoginSection.hide();

        loginWithEmailButton.hide();

        if (allowedLoginMethod == "EMAIL_AND_PHONE") {
          loginWithPhoneNumberButton.show();
        }

        emailInputBox.show();
        passwordInputBox.show();
        emailInputBoxLabel.show();
        passwordInputBoxLabel.show();
        signInButton.show();
        forgotPasswordLink.show();

        if (emailInputBox.parent().attr("id") != signInForm.attr("id")) {
          emailInputBox.parent().show();
        }

        if (passwordInputBox.parent().attr("id") != signInForm.attr("id")) {
          passwordInputBox.parent().show();
        }

        // hide forgot your password link on https://www.casivly.com/account/login
        $(".additional-links").show();
        $(".tt-required").show();

        //https://tikitoro.com/account/login
        $("#RecoverPasswordForm").show();
        $("div.title_block").show();
        $("div.bank_register").show();

        //https://leccygenesis.com/account/login
        if (SHOP.indexOf("leccygenesis") > -1) {
          $(".login-form-container").show();
        }

        //remove original login text
        if (
          $("#login").length == 1 &&
          $("#login").text() == "\n    Login\n  "
        ) {
          $("#login").show();
        }

        if (
          $("#CustomerLoginForm").length == 1 &&
          $("h2", "#CustomerLoginForm").text() == "Login"
        ) {
          $("h2", "#CustomerLoginForm").show();
        }

        //https://flourish.shop/account/login?return_url=%2Faccount
        $("header.section-header").show();

        //https://mauli-india.myshopify.com/account/login
        $('h1.h3.mb-3:contains("Login")').show();

        // https://floryo.com/
        $('a[href$="#recover"]').attr("style", "display:block !important");

        if (SHOP.indexOf("shantibanaras") == -1) {
          $('a[href$="/account/register"]').attr(
            "style",
            "display:block !important"
          );
          createAccountLink.show();
        }

        $('label[for="CustomerPassword"]').show();
        $('label[for="CustomerEmail"]').show();
        $('a[href="#recover-form"]').show();

        // https://darbeauty.com/account/login
        $('h2:contains("تسجيل الدخول")').show();

        //https://www.fionadiamonds.com/account/login
        $('h2.main-heading:contains("Customer Login")').show();

        $(':contains("Forgot your password?"):last').show();

        //https://houseofzelena.com/
        $('button:contains("Forgot your password?")').show();
        $('h1.login__heading:contains("Login")').show();

        if (SHOP.indexOf("suta") > -1) {
          $("header.Form__Header").show();
          $("div.Form__Hint").show();
          $("button.Form__ItemHelp").show();
        }

        if (SHOPIFY_THEME.indexOf("Riode") > -1) {
          $("ul.nav.nav-tabs.align-items-center").show();
        }

        if (SHOP == "thesovereignsectprebook.myshopify.com") {
          continue_text.show();
          otherLoginMethodsDiv.insertAfter(continue_text);
        }

        if (SHOP == "app99.myshopify.com") {
          $("header.form__header", signInForm).show();
          $("div.form__secondary-action", signInForm).show();
        }

        if (SHOP == "doro-fashions.myshopify.com") {
          $("#otherLoginMethodsDiv").insertAfter(signInButton);
        }
      }
    };

    let sessionInfoToken = "";
    let sendOTPInProgress = false;
    const sendOTP = async (mobileNumber, recaptchaToken) => {
      if (sendOTPInProgress) {
        console.log("sendOTP already in progress, return");
        return;
      }

      sendOTPInProgress = true;
      document.querySelector("#term_Condition-Wrapper").style.display = "none";
      document.querySelector(".continue_text").style.display = "none";
      document.querySelector("#googleLogin").style.display = "none";
      document.querySelector("#fbLogin").style.display = "none";
      document.querySelector("#login-contactus-wrapper").style.display =
        "block";

      let gtoken = null;

      if (!recaptchaToken) {
        try {
          gtoken = await grecaptcha.execute(
            "6Lf5M7sjAAAAAN6cj5PtXrtkjvSd82YlvW0MEXVK",
            { action: "submit" }
          );
        } catch (ex) {
          console.error("Error in gtoken", ex);
        }
      }

      try {
        const data = await $.ajax({
          type: "POST",
          url: "/apps/sml/client/send_otp",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            mobile: mobileNumber,
            shop: SHOP,
            modifiedShopURL: window.location.hostname,
            type: "LOGIN",
            exp: LOGIN_EXP,
            reqtimestamp: Date.now(),
            gtoken: gtoken,
            recaptchaToken: recaptchaToken,
          }),
        });

        console.log("send otp data: ", data);
        if (recaptchaToken) {
          sessionInfoToken = data.session_info;
        }

        if (data.type == "OTP_SENT_ON_EMAIL_AND_PHONE") {
          successBox.html(
            `${OTP_SENT_SUCCESS_MESSAGE} ${data.email}, ${ENTER_IT_BELOW_TEXT}`
          );
          errorBox.html("");
        } else {
          successBox.html(OTP_SENT_SUCCESSFULLY_TEXT);
          errorBox.html("");
        }

        //We can wait for sometime before allowing user to send otp again
        setTimeout(() => {
          sendOTPInProgress = false;
        }, 8000);

        return true;
      } catch (error) {
        console.error("error in send otp api ", error);
        if (error && error.responseJSON && error.responseJSON["msg"]) {
          errorBox.html(`${OTP_SEND_UNABLE}` + ` ` + error.responseJSON["msg"]);
        } else {
          errorBox.html(OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT);
        }
        successBox.html("");

        sendOTPInProgress = false;
      }

      return false;
    };

    let sendOTPEmailInProgress = false;

    const sendOTPEmail = async (email) => {
      if (sendOTPEmailInProgress) {
        console.log("sendOTPEmail already in progress, return");
        return;
      }

      sendOTPEmailInProgress = true;

      try {
        const data = await $.ajax({
          type: "POST",
          url: "https://" + SERVER_DOMAIN + "/send_otp_email",
          contentType: "application/json",
          dataType: "json",
          data: JSON.stringify({
            email: email,
            shop: SHOP,
            modifiedShopURL: window.location.hostname,
            reqtimestamp: Date.now(),
          }),
        });

        console.log("send_email_otp data: ", data);
        successBox.show();
        successBox.html(OTP_SENT_SUCCESSFULLY_TEXT_EMAIL);
        errorBox.html("");

        //We can wait for sometime before allowing user to send otp again
        setTimeout(() => {
          sendOTPEmailInProgress = false;
        }, 8000);

        return true;
      } catch (error) {
        console.error("error in send email otp api ", error);

        if (error && error.responseJSON && error.responseJSON["msg"]) {
          errorBox.html(`${OTP_SEND_UNABLE} ${error.responseJSON["msg"]}`);
        } else {
          errorBox.html(OTP_SENT_UNSUCCESSFULLY_ERROR_TEXT);
        }
        successBox.html("");

        sendOTPEmailInProgress = false;
      }

      return false;
    };

    const selectOTPScreen = (screenType, fullPhoneNumber) => {
      if (screenType == "ENTER_PHONE") {
        //show the screen where user enters phone number and clicks get otp
        getOTPButton.show();
        phoneNumberInput.show();
        mobileCountryCodeDropdown.show();

        //hide  ENTER_OTP screen
        phoneNumberDiv.html("");
        phoneNumberDiv.hide();
        emailDiv.html("");
        emailDiv.hide();
        otpInput.hide();
        otpInputSixDigit.hide();
        emailOtpInput.hide();
        submitOTPButton.hide();
        submitEmailOTPButton.hide();
        resendOTPButton.hide();
        resendEmailOTPButton.hide();
        backToLoginButton.hide();

        termsAndConditionsDiv.hide();

        //todo: hide 3rd screen
      }

      if (screenType == "ENTER_OTP") {
        //hide screen ENTER_PHONE
        getOTPButton.hide();
        phoneNumberInput.hide();
        mobileCountryCodeDropdown.hide();

        //show screen which has option to enter OTP
        phoneNumberDiv.show();

        //otpInput.show() - this sometimes add display: inline-block; so add display: block explicitly
        if (shouldUseFirebase(fullPhoneNumber)) {
          otpInputSixDigit.css("display", "block");
        } else {
          otpInput.css("display", "block");
        }

        emailOtpInput.hide();
        submitOTPButton.show();
        submitEmailOTPButton.hide();

        // resendOTPButton.show()
        resendOTPButton.css("display", "block");

        resendEmailOTPButton.hide();
        backToLoginButton.show();

        if (showTermsAndConditions) {
          termsAndConditionsDiv.show();
          submitOTPButton.attr("disabled", true);
        }

        //todo: hide ENTER_EMAIL screen
      }

      if (screenType == "ENTER_EMAIL") {
        //hide screen ENTER_PHONE
        getOTPButton.hide();
        phoneNumberInput.hide();
        mobileCountryCodeDropdown.hide();

        submitOTPButton.hide();
        submitEmailOTPButton.hide();
        resendOTPButton.hide();
        resendEmailOTPButton.hide();
        backToLoginButton.hide();
        otpInput.hide();
        otpInputSixDigit.hide();
        emailOtpInput.hide();

        phoneNumberDiv.show();
        userEmailInput.show();
        registerUserButton.show();

        emailDiv.hide();
        backToLoginButtonEmailOtp.hide();

        termsAndConditionsDiv.hide();

        if (fields_during_signup == "EMAIL_AND_NAME") {
          userFirstNameInput.show();
          userLastNameInput.show();

          if (
            SHOP == "testsimplifyloginembed.myshopify.com" ||
            SHOP == "revamp-moto.myshopify.com"
          ) {
            $("#userBirthdayInputDiv").show();
            $("#userGenderInputDiv").show();
          }
        }
      }

      if (screenType == "ENTER_OTP_EMAIL_EXISTS") {
        getOTPButton.hide();
        phoneNumberInput.hide();
        mobileCountryCodeDropdown.hide();
        userFirstNameInput.hide();
        userLastNameInput.hide();

        phoneNumberDiv.hide();
        otpInput.hide();
        otpInputSixDigit.hide();
        emailOtpInput.val("");

        // emailOtpInput.show()
        emailOtpInput.css("display", "block");

        submitOTPButton.hide();
        submitEmailOTPButton.show();
        resendOTPButton.hide();

        // resendEmailOTPButton.show()
        resendEmailOTPButton.css("display", "block");

        backToLoginButton.hide();
        backToLoginButtonEmailOtp.show();
        registerUserButton.hide();

        emailDiv.show();
        userEmailInput.hide();

        termsAndConditionsDiv.hide();

        $("#userBirthdayInputDiv").hide();
        $("#userGenderInputDiv").hide();
      }
    };

    const sanitizePhoneNumber = (phoneNumber) => {
      if (phoneNumber && phoneNumber.startsWith("0")) {
        phoneNumber = phoneNumber.substring(1);
      }

      return phoneNumber;
    };

    const shouldUseFirebase = (phoneNumber) => {
      return (
        FIREBASE_LEVEL == "ALL_NUMBERS" ||
        (FIREBASE_LEVEL == "ONLY_INTERNATIONAL_NUMBERS" &&
          !phoneNumber.startsWith("+91"))
      );
    };

    const sanitizeEmail = (email) => {
      if (email) {
        email = email.trim();

        //handling for user email input thamizhvasanthi@gmail. Com
        email = email.replace(" ", "");
      }

      return email;
    };

    const getOtpButtonClickHandler = async () => {
      successBox.html("");
      successBox.show();

      let phoneNumber = phoneNumberInput.val();
      phoneNumber = sanitizePhoneNumber(phoneNumber);

      const phoneCodeSelected = mobileCountryCodeDropdown.val();

      const fullPhoneNumber = phoneCodeSelected + phoneNumber;

      if (!validatePhoneNumber(fullPhoneNumber)) {
        errorBox.html(ENTER_VALID_NUMBER);
        return;
      }

      if (SHOP == "opatra-5041.myshopify.com") {
        otpInput.val("1234");

        submitOTPButton.click();
        return;
      }

      phoneNumberDiv.html(phoneCodeSelected + " " + phoneNumber);
      successBox.html(OTP_SENT_SUCCESSFULLY_TEXT);
      errorBox.html("");
      selectOTPScreen("ENTER_OTP", fullPhoneNumber);

      let recapchaToken;

      if (shouldUseFirebase(fullPhoneNumber)) {
        recapchaToken = await recaptchaVerifier.verify();
        console.log("token", recapchaToken);
      }

      const result = await sendOTP(fullPhoneNumber, recapchaToken);

      if (!result) {
        successBox.hide();

        selectOTPScreen("ENTER_PHONE");
        return;
      }

      if (RESEND_OTP_TIMER_ENABLED) {
        getResendOTPTimer();
      }
    };

    getOTPButton.click(() => {
      grecaptcha.ready(getOtpButtonClickHandler);
    });

    backToLoginButton.click(() => {
      successBox.hide();
      if (typeof toNoneAndBlockContentOnLoginPopup !== "undefined") {
        toNoneAndBlockContentOnLoginPopup(".phone_number_content", [
          ".name_email_content",
          ".submit_otp_content",
        ]);
      }
      selectOTPScreen("ENTER_PHONE");
    });

    backToLoginButtonEmailOtp.click(() => {
      successBox.hide();
      selectOTPScreen("ENTER_EMAIL");
    });

    const resendOTPButtonClickHandler = async () => {
      otpInput.val("");
      otpInputSixDigit.val("");
      successBox.html("");

      let phoneNumber = phoneNumberInput.val();
      phoneNumber = sanitizePhoneNumber(phoneNumber);

      const phoneCodeSelected = mobileCountryCodeDropdown.val();

      const fullPhoneNumber = phoneCodeSelected + phoneNumber;

      if (!validatePhoneNumber(fullPhoneNumber)) {
        errorBox.html(ENTER_VALID_NUMBER);
        successBox.html("");
        return;
      }

      let recapchaToken;

      if (shouldUseFirebase(fullPhoneNumber)) {
        recapchaToken = await recaptchaVerifierResendOTPButton.verify();
        console.log("resend token", recapchaToken);
      }

      const result = await sendOTP(fullPhoneNumber, recapchaToken);

      if (!result) {
        return;
      }

      if (RESEND_OTP_TIMER_ENABLED) {
        getResendOTPTimer();
      }
    };

    resendOTPButton.click(() => {
      grecaptcha.ready(resendOTPButtonClickHandler);
    });

    resendEmailOTPButton.click(async () => {
      otpInput.val("");
      otpInputSixDigit.val("");
      successBox.html("");

      let email = userEmailInput.val();
      email = sanitizeEmail(email);

      if (!validateEmail(email)) {
        errorBox.html(ENTER_VALID_EMAIL);
        return;
      }

      const result = await sendOTPEmail(email);

      if (!result) {
        return;
      }
    });

    let registerUserInProgress = false;
    const registerUser = async (
      mobile,
      email,
      firstName,
      lastName,
      customerNote
    ) => {
      if (registerUserInProgress) {
        console.log("registerUserInProgress already in progress, return");
        return;
      }

      registerUserInProgress = true;

      try {
        const data = await $.ajax({
          type: "POST",
          url: "https://" + SERVER_DOMAIN + "/register",
          data: JSON.stringify({
            mobile: mobile,
            shop: SHOP,
            email: email,
            first_name: firstName,
            last_name: lastName,
            note: customerNote,
            reqtimestamp: Date.now(),
          }),
          contentType: "application/json",
          dataType: "json",
        });

        console.log("registerUser data: ", data);

        if (data.type == "EXISTING_USER_WITH_EMAIL_FOUND") {
          registerUserInProgress = false;
          successBox.html("");
          return { type: data.type };
        } else {
          successBox.html(SUCCESSFULLY_REGISTERED_USER);
          errorBox.html("");

          emailInputBox.val(data.email);
          passwordInputBox.val(data.xattr);

          //As Shopify login takes time user tends to press register button multiple times, causing multiple backend calls
          //We can wait for sometime to let succesful Shopify login complete
          setTimeout(() => {
            registerUserInProgress = false;
          }, 8000);

          return { type: "USER_REGISTERED_SUCCESSFULLY" };
        }
      } catch (error) {
        console.error("error in registerUser otp api ", error);
        if (error && error.responseJSON && error.responseJSON["msg"]) {
          let errorMessage = error.responseJSON["msg"];
          errorBox.html("Error:: " + errorMessage);
        } else {
          errorBox.html(USER_REGISTRATION_UNABLED);
        }
        successBox.html("");

        registerUserInProgress = false;
        return { error: error };
      }
    };

    let validateOTPInProgress = false;
    const validateOTP = async (mobileNumber, otp) => {
      if (validateOTPInProgress) {
        console.log("validateOTP already in progress, return");
        return;
      }

      validateOTPInProgress = true;

      try {
        const data = await $.ajax({
          type: "POST",
          url: "https://" + SERVER_DOMAIN + "/validate_otp",
          data: JSON.stringify({
            mobile: mobileNumber,
            shop: SHOP,
            otp: otp,
            type: "LOGIN",
            exp: LOGIN_EXP,
            reqtimestamp: Date.now(),
            sessionInfoToken: sessionInfoToken,
          }),
          contentType: "application/json",
          dataType: "json",
        });

        console.log("data: ", data);

        if (data.type == "LOGIN") {
          successBox.html(OTP_SUCCESSFULLY_VERIFIED);
          errorBox.html("");

          emailInputBox.val(data.email);
          passwordInputBox.val(data.xattr);

          //As Shopify login takes time user tends to press register button multiple times, causing multiple backend calls
          //We can wait for sometime to let succesful Shopify login complete
          setTimeout(() => {
            validateOTPInProgress = false;
          }, 8000);

          return { type: "LOGIN_SUCCESSFUL" };
        }

        if (data.type == "REGISTER") {
          validateOTPInProgress = false;

          successBox.html(ENTER_EMAIL_REGISTER_LOGIN);
          errorBox.html("");

          selectOTPScreen("ENTER_EMAIL");

          return { type: "NEW_USER" };
        }

        validateOTPInProgress = false;
        console.log("validateOTP: user should never reach here");
      } catch (error) {
        console.error("error in validate OTP API ", error);
        if (typeof toNoneAndBlockContentOnLoginPopup !== "undefined") {
          toNoneAndBlockContentOnLoginPopup(".submit_otp_content", [
            ".phone_number_content",
            ".name_email_content",
          ]);
        }
        otpInput.val("");
        otpInputSixDigit.val("");

        if (error && error.responseJSON && error.responseJSON["msg"]) {
          errorBox.html("Error: " + error.responseJSON["msg"]);
        } else {
          errorBox.html(OTP_VALIDATION_UNABLED);
        }
        successBox.html("");

        validateOTPInProgress = false;

        return { error: error };
      }

      return false;
    };

    let validateOTPEmailInProgress = false;
    const validateOTPEmail = async (
      email,
      phone,
      otp,
      firstName,
      lastName,
      customerNote
    ) => {
      if (validateOTPEmailInProgress) {
        console.log("validateOTPEmail already in progress, return");
        return;
      }

      validateOTPEmailInProgress = true;

      try {
        const validateOtpEmailExistingData = await $.ajax({
          type: "POST",
          url: "https://" + SERVER_DOMAIN + "/validate_otp_existing_email",
          data: JSON.stringify({
            mobile: phone,
            email: email,
            shop: SHOP,
            otp: otp,
            first_name: firstName,
            last_name: lastName,
            note: customerNote,
            reqtimestamp: Date.now(),
          }),
          contentType: "application/json",
          dataType: "json",
        });

        console.log("data: ", validateOtpEmailExistingData);

        if (validateOtpEmailExistingData.type == "USER_UPDATED_SUCCESSFULLY") {
          successBox.html(OTP_SUCCESSFULLY_VERIFIED);
          errorBox.html("");

          emailInputBox.val(validateOtpEmailExistingData.email);
          passwordInputBox.val(validateOtpEmailExistingData.xattr);

          //As Shopify login takes time user tends to press register button multiple times, causing multiple backend calls
          //We can wait for sometime to let succesful Shopify login complete
          setTimeout(() => {
            validateOTPEmailInProgress = false;
          }, 8000);

          return true;
        }

        validateOTPEmailInProgress = false;
        console.log("validateOTPEmail: This should never get called");
      } catch (error) {
        console.error("error in validate email otp api ", error);

        if (error && error.responseJSON && error.responseJSON["msg"]) {
          errorBox.html("Error: " + error.responseJSON["msg"]);
        } else {
          errorBox.html(OTP_VALIDATION_UNABLED);
        }
        successBox.html("");

        validateOTPEmailInProgress = false;
      }

      return false;
    };

    registerUserButton.click(async () => {
      let phoneNumber = phoneNumberInput.val();
      phoneNumber = sanitizePhoneNumber(phoneNumber);

      const phoneCodeSelected = mobileCountryCodeDropdown.val();

      const fullPhoneNumber = phoneCodeSelected + phoneNumber;

      let email = userEmailInput.val();
      email = sanitizeEmail(email);

      const firstName = userFirstNameInput.val();
      const lastName = userLastNameInput.val();

      if (fields_during_signup == "EMAIL_AND_NAME") {
        if (!firstName) {
          successBox.html("");
          errorBox.html(ENTER_VALID_FIRST_NAME);
          return;
        }

        if (!lastName) {
          successBox.html("");
          errorBox.html(ENTER_VALID_LAST_NAME);
          return;
        }
      }

      //check if email valid
      if (!validateEmail(email)) {
        successBox.html("");
        errorBox.html(ENTER_VALID_EMAIL);
        return;
      }

      const customerNote = getCustomerNoteValue();

      console.log("Value of customer note is: ", customerNote);

      const result = await registerUser(
        fullPhoneNumber,
        email,
        firstName,
        lastName,
        customerNote
      );

      if (result.error) {
        return;
      }
      if (result.type == "EXISTING_USER_WITH_EMAIL_FOUND") {
        const emailSent = await sendOTPEmail(email);

        if (!emailSent) {
          return;
        }
        emailDiv.html(email);
        selectOTPScreen("ENTER_OTP_EMAIL_EXISTS");
        return;
      }

      if (result.type == "USER_REGISTERED_SUCCESSFULLY") {
        signInButton.click();
        return;
      }
    });

    const getCustomerNoteValue = () => {
      const customerNoteInputBox = $("input[name=customer\\[note\\]]");
      let customerNote = customerNoteInputBox.val();

      let gender = null;
      let birthday = null;

      if (
        SHOP == "revamp-moto.myshopify.com" ||
        SHOP == "testsimplifyloginembed.myshopify.com"
      ) {
        gender = $('[name="userGenderInput"]:checked').val();
        birthday = $("#userBirthdayInput").val();

        if (!customerNote) {
          customerNote = "";
        }

        if (birthday) {
          customerNote += ` [Birthday]: ${birthday}`;
        }

        if (gender) {
          customerNote += ` [Gender]: ${gender}`;
        }
      }

      console.log("Value of customer note is: ", customerNote);

      return customerNote;
    };

    const showButtonLoadingAnimation = (btn) => {
      btn.addClass("otp-btn-loading");
      btn.text("");
    };

    const buttonRemoveLoadingAnimation = (btn, btnText) => {
      btn.removeClass("otp-btn-loading");
      btn.text(btnText);
    };

    submitOTPButton.click(async () => {
      let phoneNumber = phoneNumberInput.val();
      phoneNumber = sanitizePhoneNumber(phoneNumber);

      const phoneCodeSelected = mobileCountryCodeDropdown.val();

      const fullPhoneNumber = phoneCodeSelected + phoneNumber;

      let otp;
      if (shouldUseFirebase(fullPhoneNumber)) {
        otp = otpInputSixDigit.val();

        if (!otp || otp.length != 6) {
          successBox.html("");
          errorBox.html(ENTER_VALID_SIX_DIGIT_OTP);
          return;
        }
      } else {
        otp = otpInput.val();

        if (!otp || otp.length != 4) {
          successBox.html("");
          errorBox.html(ENTER_VALID_OTP);
          return;
        }
      }

      showButtonLoadingAnimation(submitOTPButton);

      const result = await validateOTP(fullPhoneNumber, otp);

      if (result.type == "LOGIN_SUCCESSFUL") {
        signInButton.click();
        return;
      }

      if (result.type == "NEW_USER") {
        buttonRemoveLoadingAnimation(submitOTPButton, SUBMIT_OTP_TEXT);
        // This below function is to show the name and email input fields.
        if (typeof toNoneAndBlockContentOnLoginPopup !== "undefined") {
          toNoneAndBlockContentOnLoginPopup(".name_email_content", [
            ".phone_number_content",
            ".submit_otp_content",
          ]);
        }
        return;
      }

      if (result.error) {
        buttonRemoveLoadingAnimation(submitOTPButton, SUBMIT_OTP_TEXT);
        return;
      }

      console.log("submitOTPButton.click => We should never reach here");
    });

    submitEmailOTPButton.click(async () => {
      let phoneNumber = phoneNumberInput.val();
      phoneNumber = sanitizePhoneNumber(phoneNumber);

      const phoneCodeSelected = mobileCountryCodeDropdown.val();
      const fullPhoneNumber = phoneCodeSelected + phoneNumber;

      let email = userEmailInput.val();
      email = sanitizeEmail(email);

      if (!validateEmail(email)) {
        errorBox.html(ENTER_VALID_EMAIL);
        return;
      }

      const otp = emailOtpInput.val();

      if (!otp || otp.length != 4) {
        successBox.html("");
        errorBox.html(ENTER_VALID_OTP);
        return;
      }

      const firstName = userFirstNameInput.val();
      const lastName = userLastNameInput.val();

      const customerNote = getCustomerNoteValue();

      showButtonLoadingAnimation(submitEmailOTPButton);

      const result = await validateOTPEmail(
        email,
        fullPhoneNumber.replace(" ", ""),
        otp,
        firstName,
        lastName,
        customerNote
      );

      if (result) {
        signInButton.click();
      } else {
        buttonRemoveLoadingAnimation(submitEmailOTPButton, SUBMIT_OTP_TEXT);
      }
    });

    otpInput.keyup(async () => {
      const otp = otpInput.val();

      if (otp.length != 4) {
        return;
      }

      otpInput.trigger("blur");

      if (
        showTermsAndConditions &&
        !termsAndConditionsCheckbox.is(":checked")
      ) {
        return;
      }

      submitOTPButton.click();
    });

    otpInputSixDigit.keyup(async () => {
      const otp = otpInputSixDigit.val();

      if (otp.length != 6) {
        return;
      }

      otpInputSixDigit.trigger("blur");

      if (
        showTermsAndConditions &&
        !termsAndConditionsCheckbox.is(":checked")
      ) {
        return;
      }

      submitOTPButton.click();
    });

    emailOtpInput.keyup(async () => {
      const otp = emailOtpInput.val();

      if (otp.length != 4) {
        return;
      }

      emailOtpInput.trigger("blur");

      submitEmailOTPButton.click();
    });

    // if ('OTPCredential' in window && autoFillOTPEnabled) {
    //   window.addEventListener('DOMContentLoaded', e => {
    //     const ac = new AbortController();

    //     signInForm.submit('submit', e => {
    //         ac.abort();
    //     });

    //     navigator.credentials.get({
    //       otp: { transport:['sms'] },
    //       signal: ac.signal
    //     }).then(otp => {
    //         console.log("OTP IS: ", otp)
    //         const otpCode = otp.code

    //         if (otpCode && otpCode.length == 4 && !isNaN(otpCode)) {
    //             otpInput.val(otpCode)
    //         }

    //         submitOTPButton.click()

    //     }).catch(err => {
    //       console.error(err);
    //     });
    //   });
    // }

    //disable form submit on pressing enter key
    signInForm.on("keyup keypress", function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    });

    const getResendOTPTimer = () => {
      resendOTPButton.prop("disabled", true);

      let timeleft = 60;
      const resendButtonTimer = setInterval(() => {
        timeleft -= 1;
        if (timeleft <= 0) {
          clearInterval(resendButtonTimer);
          resendCountdownTimer.html("Press button to re-send OTP");
          resendOTPButton.prop("disabled", false);
        } else {
          resendCountdownTimer.html(
            "Please wait " + timeleft + "&nbsp" + "seconds to re-send OTP"
          );
        }
      }, 1000);
    };

    const loginUsingSocialToken = () => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has("simplysocialtoken") && urlParams.get("email")) {
        const simplysocialtoken = urlParams.get("simplysocialtoken");
        const email = urlParams.get("email");
        $.ajax({
          type: "POST",
          url: "https://" + SERVER_DOMAIN + "/validate_social_auth_token",
          data: JSON.stringify({
            simplysocialtoken: simplysocialtoken,
            email: email,
            shop: SHOP,
            reqtimestamp: Date.now(),
          }),
          beforeSend: function () {
            displaySpinner(true);
          },
          success: function (data) {
            console.log("data here is: ", data);
            emailInputBox.val(data.email);
            passwordInputBox.val(data.xattr);
            signInButton.click();
            setTimeout(() => {
              displaySpinner(false);
            }, 5000);
          },
          error: function (xhr, status, errorMessage) {
            displaySpinner(false);
            console.error(
              "error in validate social login api ",
              xhr.responseJSON
            );
            if (xhr && xhr.responseJSON && xhr.responseJSON["msg"]) {
              errorBox.html("Error in logging in " + xhr.responseJSON["msg"]);
            } else {
              errorBox.html("Error in logging in");
            }
            successBox.html("");
          },
          contentType: "application/json",
          dataType: "json",
        });
      }
      return;
    };

    let recaptchaVerifier;
    let recaptchaVerifierResendOTPButton;
    const initFirebase = () => {
      if (FIREBASE_LEVEL == "DISABLED") {
        return;
      }

      const app = initializeApp(FIREBASE_CONFIG);

      const googleRecaptchaAuth = getAuth();
      recaptchaVerifier = new RecaptchaVerifier(
        "getOTPButton",
        {
          size: "invisible",
          callback: (recapchaToken) => {
            console.log("recapcha called");
          },
          "expired-callback": () => {
            console.error("expired callback, reload page??");
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
          },
        },
        googleRecaptchaAuth
      );

      recaptchaVerifierResendOTPButton = new RecaptchaVerifier(
        "resendOTPButton",
        {
          size: "invisible",
          callback: (recapchaToken) => {
            console.log("recapcha called");
          },
          "expired-callback": () => {
            console.error("expired callback, reload page??");
            // Response expired. Ask user to solve reCAPTCHA again.
            // ...
          },
        },
        googleRecaptchaAuth
      );
    };

    const initPage = () => {
      if (selected_country_code == "All") {
        const ipInfoInterval = setInterval(() => {
          if (!isIpInfoRequestPending) {
            mobileCountryCodeDropdown.val(PHONE_CODE);
            clearInterval(ipInfoInterval);
          }
        }, 100);
      }
      if (selected_country_code != "All") {
        mobileCountryCodeDropdown.prop("disabled", true);
        mobileCountryCodeDropdown.css("-webkit-appearance", "none");
        mobileCountryCodeDropdown.css("-moz-appearance", "none");
      }

      if (fb_login_enabled || google_login_enabled) {
        loginUsingSocialToken();
      }

      if (localStorage.getItem(CRED_KEY_STRING) && isBiometricLoginEnabled) {
        loginWithBiometricButton.show();
        const userCreds = JSON.parse(localStorage.getItem(CRED_KEY_STRING))[0];
        loginWithBiometricButton.text(
          loginWithBiometricButton.text() + " as " + userCreds.userEmail
        );
      } else {
        //Basically treat as isBiometricLoginEnabled is false
        isBiometricLoginEnabled = false;
      }

      if (
        allowedLoginMethod == "EMAIL_AND_PHONE" ||
        fb_login_enabled ||
        google_login_enabled ||
        isBiometricLoginEnabled
      ) {
        continue_text.show();
      } else {
        continue_text.hide();
      }

      if (allowedLoginMethod == "EMAIL_AND_PHONE" || isBiometricLoginEnabled) {
        otherLoginMethodsDiv.show();
      }

      if (simplifyURLParams.has("checkout_url")) {
        //there is possibility that input for checkout_url is present , only in cases where we are directly injecting form in liquid, it might not be present

        const checkoutURLInput = $("input[name=checkout_url]", signInForm);
        console.log("checkoutURLInput==", checkoutURLInput);
        // if (checkoutURLInput.length > 0) {
        //   //clear relative_route as checkout_url input already present
        //   relative_route = "";
        // } else {
        //   //set relative_route as checkout_url input
        //   relative_route = simplifyURLParams.get("checkout_url");
        // }
      }

      if (relative_route && relative_route.length > 0) {
        //Redirect to a custom endpoint

        const custom_url = `<input type="hidden" name="checkout_url" value="${location.href}">`;
        signInForm.append(custom_url);
      }

      if (SHOPIFY_THEME.indexOf("Lucent PROD") > -1) {
        $(".account-page-title").hide();

        getOTPButton.addClass("button-primary");
        submitOTPButton.addClass("button-primary");
        submitEmailOTPButton.addClass("button-primary");
        registerUserButton.addClass("button-primary");
      }

      if (SHOP.indexOf("suta") > -1) {
        getOTPButton.addClass(
          "Form__Submit Button Button--primary Button--full"
        );
        submitOTPButton.addClass(
          "Form__Submit Button Button--primary Button--full"
        );
        submitEmailOTPButton.addClass(
          "Form__Submit Button Button--primary Button--full"
        );
        registerUserButton.addClass(
          "Form__Submit Button Button--primary Button--full"
        );
      } else {
        submitOTPButton.addClass("submitOTPButtonClass");
        submitEmailOTPButton.addClass("submitEmailOTPButtonClass");

        const submitBtnClassList = signInButton.attr("class");
        if (submitBtnClassList) {
          getOTPButton.addClass(submitBtnClassList);
          submitOTPButton.addClass(submitBtnClassList);
          submitEmailOTPButton.addClass(submitBtnClassList);
          registerUserButton.addClass(submitBtnClassList);
        }
      }

      if (SHOP.indexOf("glow-hub-beauty") > -1) {
        mobileCountryCodeDropdown.css("padding", "16px");
        $(".selectbox-wrapper").css("margin-top", "40px");
        getOTPButton.text("Send Code");
      }

      if (SHOP.indexOf("sooqaman.myshopify.com") > -1) {
        submitOTPButton.addClass("black-spinner");
        submitEmailOTPButton.addClass("black-spinner");
        continue_text.hide();
      }

      if (SHOP.indexOf("therouc") > -1) {
        $("#resendOTPButton").css("color", "black");
        $("#resendEmailOTPButton").css("color", "black");
      }

      if (SHOP.indexOf("chickenwayindia") > -1) {
        resendOTPButton.css("color", "#D11243");
        resendEmailOTPButton.css("color", "#D11243");
      }

      if (SHOP == "thesovereignsectprebook.myshopify.com") {
        getOTPButton.text("Get One Time Passcode");
        resendOTPButton.text("Resend One Time Passcode");
        submitOTPButton.text("Submit One Time Passcode");
        const newDiv = `
                  <div id="troubleLoggingInDiv">
                      <hr style="margin: 10px">
                      <h2>Trouble Logging In / Enter Phone #</h2>
                  </div>
                  `;
        mobileOTPLoginSection.prepend(newDiv);
      }

      if (SHOP == "vannaksemshop.myshopify.com") {
        getOTPButton.text("Get One Time Code");
        resendOTPButton.text("Resend One Time Code");
        submitOTPButton.text("Submit One Time Code");
      }

      if (SHOP == "officialhouseofzelena.myshopify.com") {
        $('option[value="+91"]').text("+91");
      }

      if (SHOP == "app99.myshopify.com") {
        continue_text.text("Or");
      }

      if (allowedLoginMethod == "ONLY_PHONE") {
        signInForm.css("padding-bottom", "38px");
      }

      if (showTermsAndConditions) {
        termsAndConditionsCheckbox.click(function () {
          if (termsAndConditionsCheckbox.is(":checked")) {
            submitOTPButton.attr("disabled", false);
          } else {
            submitOTPButton.attr("disabled", true);
          }
        });
      }

      // signInForm.show()
      signInForm.css("visibility", "visible");

      if (
        allowedLoginMethod == "EMAIL_AND_PHONE" ||
        allowedLoginMethod == "ONLY_PHONE"
      ) {
        //default is login with phone number and otp
        loginWithPhoneNumberButton.click();
      }

      if (allowedLoginMethod == "ONLY_EMAIL_PASSWORD") {
        loginWithEmailButton.click();
      }

      if (SHOP == "opatra-5041.myshopify.com") {
        $("#simplify-login-sign-up-text").css("font-size", "14px");
      }

      initFirebase();
    };

    initPage();
  };

  const loadSettings = (data) => {
    is_disabled = !data.is_enabled;
    allowedLoginMethod = data.allowed_login_method;
    STORE_LANG = data.store_lang;
    LOGIN_EXP = data.login_exp;
    fields_during_signup = data.fields_during_signup;
    fb_login_enabled = data.fb_login_enabled;
    google_login_enabled = data.google_login_enabled;
    selected_country_code = data.selected_country_code;
    relative_route = data.relative_route;
    isBiometricLoginEnabled = data.device_based_login_enabled;

    if (data.firebase_level) {
      FIREBASE_LEVEL = data.firebase_level;
    }

    if (data.default_country_code) {
      PHONE_CODE = data.default_country_code;
    }

    if (data.firebase_config) {
      FIREBASE_CONFIG = data.firebase_config;
    }

    $(document).ready(function () {
      initExtension();
    });
  };

  if (window.smlSettings && Shopify.shop != "lbindia.myshopify.com") {
    // don't use smlSettings on lbindia as there is older code injected in liquid for hiding signin form
    loadSettings(smlSettings);
  } else {
    $.ajax({
      type: "GET",
      url: "https://" + SERVER_DOMAIN + "/settings?shop=" + SHOP,
      success: function (data) {
        console.log("settings data: ", data);
        loadSettings(data);
      },
      error: function (xhr, status, errorMessage) {
        console.error("error in settings api ", xhr.responseJSON);
      },
      contentType: "application/json",
      dataType: "json",
    });
  }
})(simplify_jQuery_3_6_0);
